import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-relative tw-w-screen tw-h-screen tw-overflow-hidden tw-bg-exam-dark tw-text-white tw-flex tw-flex-col" }
const _hoisted_2 = {
  key: 1,
  class: "tw-fixed tw-z-10 tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-bg-exam-dark"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-4xl tw-font-bold tw-mb-1.5" }, "Error", -1)
const _hoisted_4 = { class: "tw-text-3xl" }
const _hoisted_5 = {
  key: 2,
  class: "tw-flex-shrink-0 tw-h-14 tw-bg-exam-header tw-flex tw-items-center tw-justify-center tw-z-10"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-xl tw-font-semibold" }, "ICAO Exam", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 3,
  class: "tw-flex-shrink-0 tw-bg-exam-header tw-flex tw-items-center tw-gap-4 tw-px-6 tw-py-3 tw-z-10"
}
const _hoisted_9 = { class: "tw-bg-module-badge tw-rounded-lg tw-px-4 tw-py-2 tw-flex tw-items-center tw-justify-center" }
const _hoisted_10 = { class: "tw-text-xl tw-font-bold" }
const _hoisted_11 = { class: "tw-flex tw-flex-col" }
const _hoisted_12 = { class: "tw-text-xl tw-font-bold tw-capitalize" }
const _hoisted_13 = { class: "tw-text-sm tw-text-gray-400 tw-uppercase tw-flex tw-items-center tw-gap-1" }
const _hoisted_14 = { class: "tw-flex-1 tw-flex tw-flex-col tw-overflow-hidden tw-relative" }
const _hoisted_15 = {
  key: 4,
  class: "tw-flex-shrink-0 tw-h-[35vh]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModuleTypeIcon = _resolveComponent("ModuleTypeIcon")!
  const _component_ExamIntro = _resolveComponent("ExamIntro")!
  const _component_ExamQuestion = _resolveComponent("ExamQuestion")!
  const _component_ExaminerVideo = _resolveComponent("ExaminerVideo")!
  const _component_ProgressIndicator = _resolveComponent("ProgressIndicator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isFullBleedImage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "tw-absolute tw-inset-0 tw-bg-center tw-bg-cover tw-bg-no-repeat",
          style: _normalizeStyle({ backgroundImage: `url(${_ctx.originUrl}${_ctx.view.image})` })
        }, null, 4))
      : _createCommentVNode("", true),
    (_ctx.examError.isError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.examError.message), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.view.isQuestion)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.moduleKey), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.moduleTitle), 1),
            _createElementVNode("span", _hoisted_13, [
              _createVNode(_component_ModuleTypeIcon, {
                type: _ctx.view.type
              }, null, 8, ["type"]),
              _createTextVNode(" " + _toDisplayString(_ctx.view.type), 1)
            ])
          ])
        ])),
    _createElementVNode("div", _hoisted_14, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ExamIntro, {
            key: 0,
            view: { content: 'LOADING...' }
          }, null, 8, ["view"]))
        : (_ctx.view.isQuestion)
          ? (_openBlock(), _createBlock(_component_ExamQuestion, {
              key: 1,
              view: _ctx.view
            }, null, 8, ["view"]))
          : (_openBlock(), _createBlock(_component_ExamIntro, {
              key: 2,
              view: _ctx.view
            }, null, 8, ["view"]))
    ]),
    (_ctx.view.video && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(_component_ExaminerVideo)
        ]))
      : _createCommentVNode("", true),
    (_ctx.view.isQuestion && !_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressIndicator, {
          key: 5,
          class: "tw-flex-shrink-0"
        }))
      : _createCommentVNode("", true)
  ]))
}